import React, {useEffect} from "react";
import {Layout} from "@components/layout/Layout";
// import {Link} from "react-router-dom";
// import {AUTH_SIGN_UP} from "../../../constants";

export const AffiliateProgram = () => {

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    // Bind events
    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const handleSignUpToggle = (isOpen) => {
  //   dispatch(toggleSignUpModal(isOpen));
  // };

  useEffect(() => {
    document.body.classList.add('main-page');
    return () => {
      document.body.classList?.remove('main-page');
    };
  }, []);

  return (<Layout>
    <div className="basic-main">
      <div className="affiliate-program-title-section">
        <div className="container">
          <figure className="percent-img"><img src={ require("@assets/images/main/45.svg").default} alt="img"/></figure>
          <h1 className="large-title">Be the First to Earn with CRONIKA!</h1>
          <p>Join our brand-new affiliate program and start earning with the most rewarding RevShare model in the
            industry. We offer an exclusive up to  45% RevShare commission on all referred traders, ensuring you maximize your
            profits effortlessly.</p>
            {/* <Link className="basic-button" to={AUTH_SIGN_UP}>Join now</Link> */}
            <a className="basic-button" href=" https://partner.cronika.com">Join now</a>
        </div>
      </div>
      <div className="container">
        <h2>Join now</h2>
        <div className="join-now-box section">
          <div className="box">
            <figure><img src={ require("@assets/images/main/trading-icon-yellow.svg").default} alt="icon"/></figure>
            REAL-TIME <br/>STATISTICK
          </div>
          <div className="box">
            <figure><img src={ require("@assets/images/main/telegram-icon-yellow.svg").default} alt="icon"/></figure>
            tELEGRAM <br/>BOT
          </div>
          <div className="box">
            <figure><img src={ require("@assets/images/main/verification-icon-yellow.svg").default} alt="icon"/></figure>
            lOCAL <br/>MANAGER
          </div>
          <div className="box">
            <figure><img src={ require("@assets/images/main/market-icon-yellow.svg").default} alt="icon"/></figure>
            pROMO <br/>MATERIALS
          </div>
          <div className="box">
            <figure><img src={ require("@assets/images/main/cronika-icon-yellow.svg").default} alt="icon"/></figure>
            eVENTS AND <br/>CONTESTS
          </div>
          <div className="box">
            <figure><img src={ require("@assets/images/main/deposits-icon-yellow.svg").default} alt="icon"/></figure>
            wE PAY <br/>EVERY WEEK
          </div>
        </div>
        <div className="benefits-section section">
          <h2>Why Partner with Us?</h2>
          <div className="instruments-box">
            <div className="box"><img className="pillow" src={ require("@assets/images/main/45_transparent.png")} alt="img"/>
              <h3>High Payouts: <mark>Enjoy an <br/>industry-leading up to </mark> 45% RevShare <br/>
                <mark>with no hidden fees.</mark>
              </h3>
            </div>
            <div className="box"><img src={ require("@assets/images/main/instrument-bg06.png")} alt="img"/>
              <h3>Advanced Tracking Tools: <br/>
                <mark>Monitor your performance with <br/>real-time analytics and reporting.</mark>
              </h3>
            </div>
            <div className="box"><img src={ require("@assets/images/main/instrument-bg07.png")} alt="img"/>
              <h3>Timely Payments: <mark>Get your <br/>earnings on time, every time.</mark></h3>
            </div>
            <div className="box"><img src={ require("@assets/images/main/instrument-bg08.png")} alt="img"/>
              <h3>Global Reach: <mark>Attract traders <br/>from around the world with <br/>our multilingual platform.
              </mark></h3>
              <figure className="basic-logo"><img src={ require("@assets/images/main/basic-logo.svg").default} alt="logo"/></figure>
            </div>
          </div>
          <div className="benefit-item">
            <figure><img src={ require("@assets/images/main/benefit-img.png")} alt="img"/></figure>
            <h3>Marketing Support: <mark>Access top-tier promotional materials and personalized assistance.</mark></h3>
          </div>
        </div>
        <div className="who-can-join-section section"><img src={ require("@assets/images/main/who-can-join-img.jpg")} alt="img"/>
          <h2>Who Can Join?</h2>
          <h3>
            <mark>Whether you’re a digital marketer, blogger, influencer, or traffic expert, our program is designed to
              help you
            </mark>
            monetize your audience <mark>effectively.</mark></h3>
        </div>
        <div className="section">
          <h2>How It Works</h2>
          <div className="how-it-works-box">
            <div className="box">
              <h3>Sign Up <mark>– Join the Cronika affiliate program for free.</mark></h3>
            </div>
            <div className="box">
              <h3>Promote <mark>– Share your unique referral link and attract traders.</mark></h3>
            </div>
            <div className="box">
              <figure className="percent-img"><img style={{ width: '100%' }} src={ require("@assets/images/main/45.svg").default} alt="img"/></figure>
              <h3>Earn <mark>– Get</mark> up to  45% of the revenue <mark>generated by your referrals.</mark></h3>
            </div>
          </div>
        </div>
        <div className="affiliate-program-footer-section section">
          <h2>Don’t Miss Out!</h2>
          <h3 style={{ marginBottom: 40 }}>Be part of one of the fastest-growing affiliate programs in the industry. Start earning today!</h3>
          {/* <Link
          className="basic-button" to={AUTH_SIGN_UP}>Join now</Link> */}
                      <a className="basic-button" href=" https://partner.cronika.com">Join now</a>

        </div>
          <div className="support-header-section support-afilate-section section">
          <div className="support-contacts afilate-contacts">
          <div className="box afilate-box">
            <h2 style={{ textAlign:"left", marginBottom:'10px' }}>Have questions about our affiliate program?</h2>
            <h3>Write us an email!</h3>
            </div>
            <div className="box">
              <figure className="contact-icon"><img src={require("@assets/images/main/email-icon-black.svg").default}
                                                    alt="icon"/></figure>
              <span className="contact-title">Email</span><a href="mailto:affiliate@cronika.com">affiliate@cronika.com</a>
              <p>Ask a question and we'll respond within one business day</p>
            </div>

          </div>
        </div>
        </div>
      </div>
  </Layout>);
};

export default AffiliateProgram;
